<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Saldo Awal - Hutang</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small"> Keuangan / Master / Saldo Awal / Hutang</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          icon="pi pi-plus"
          label="Saldo Awal - Hutang"
          class="mr-2"
          @click="$router.push({ name: 'SaldoAwalHutangAdd' })"
        />
        <Button
          :loading="isLoadingTemplateImport"
          icon="pi pi-download"
          label="Template"
          class="p-button-success mr-2"
          @click="downloadTemplate"
        />
        <FileUpload
          :loading="isLoadingImport"
          type="file"
          name="file"
          icon="pi pi-upload"
          class="p-button mr-2"
          chooseLabel="Import"
          mode="basic"
          :customUpload="true"
          @uploader="importFile"
          :maxFileSize="10000000"
        />
        <Button
          :loading="isLoadingExportExcel"
          icon="pi pi-file-excel"
          label="Export"
          class="p-button-outlined mr-2"
          @click="exportDataExcel"
        />
        <Button
          :loading="isLoadingExportPdf"
          icon="pi pi-print"
          label="Print"
          class="p-button-outlined"
          @click="exportDataPdf"
        />
      </div>
      <grid-hutang
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        @request="onRequestData"
        @edit="onEditData"
      />
    </div>
    <Dialog
      :header="pdfTitle"
      v-model:visible="dialogViewer"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '90vw' }"
      :modal="true"
    >
      <div>
        <embed
          :src="pdfSource"
          type="application/pdf"
          width="100%"
          height="600px"
        />
      </div>
      <template #footer>
        <Button
          type="button"
          label="Download"
          icon="pi pi-download"
          class="p-button-text mr-2"
          @click="onDownloadPdf"
        />
        <Button
          type="button"
          label="Print"
          icon="pi pi-print"
          @click="onPrintPdf"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import SaldoAwalHutangService from '@/services/SaldoAwalHutangService'
import errorHandler from '@/helpers/error-handler'
import Hotkey from '@/components/Hotkey'
import GridHutang from '@/components/keuangan/saldo/GridHutang'
import { saveAs } from 'file-saver'

export default {
  components: {
    GridHutang,
    Hotkey,
  },
  data() {
    return {
      dataService: null,
      dialogHapus: false,
      dialogViewer: false,
      faktur: 0,
      pdfSource: '',
      pdfTitle: 'PDF Viewer',
      pdfFilename: '',
      isLoading: false,
      isLoadingSave: false,
      isLoadingExportPdf: false,
      isLoadingExportExcel: false,
      isLoadingImport: false,
      isLoadingTemplateImport: false,
      fileUpload: null,
      items: [],
      form: {},
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: 'pi_no',
        sortOrder: 1,
        filters: null,
      },
    }
  },
  created() {
    this.dataService = new SaldoAwalHutangService()
  },
  mounted() {
    this.loadGridData()
  },
  methods: {
    onRequestData(e) {
      this.options = e
      this.loadGridData()
    },
    loadGridData() {
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.isLoading = true
      this.dataService
        .paginate(page, perPage, sortField, sortOrder, filters)
        .then((res) => {
          this.items = res.data.data
          this.totalRecords = res.data.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Saldo Awal Hutang', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onEditData(data) {
      this.$router.push({
        name: 'SaldoAwalHutangEdit',
        params: { id: data.supplier_id },
      })
    },
    exportDataPdf() {
      this.isLoadingExport = true
      this.dataService
        .exportPdf()
        .then((res) => {
          if (res.status !== 200) {
            this.$toast.add({
              severity: 'error',
              summary: 'Export Saldo Awal Hutang',
              detail: 'Gagal mengunduh Saldo Awal Hutang.',
              life: 3000,
            })
          } else {
            const blob = new Blob([res.data], { type: 'application/pdf' })
            const pdfUrl = URL.createObjectURL(blob)
            this.pdfSource = pdfUrl + '#toolbar=0'
            this.pdfFilename = `saldo-awal-hutang.pdf`
            this.pdfTitle = 'PDF Viewer (' + this.pdfFilename + ')'
            this.dialogViewer = true
          }
        })
        .catch((err) => {
          errorHandler(err, 'Export Saldo Awal Hutang', this)
        })
      this.isLoadingExportPdf = false
    },
    onPrintPdf() {
      const iframe = document.createElement('iframe')
      iframe.src = this.pdfSource
      iframe.style.display = 'none'
      document.body.appendChild(iframe)

      // Use onload to make pdf preview work on firefox
      iframe.onload = () => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
    },
    onDownloadPdf() {
      saveAs(this.pdfSource, this.pdfFilename)
    },
    exportDataExcel() {
      this.isLoadingExportExcel = true
      this.dataService
        .exportExcel()
        .then((res) => {
          if (res.status !== 200) {
            this.$toast.add({
              severity: 'error',
              summary: 'Export Saldo Awal Hutang',
              detail: 'Gagal mengunduh Saldo Awal Hutang.',
              life: 3000,
            })
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'saldo-awal-hutang.xls')
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((err) => {
          errorHandler(err, 'Export Saldo Awal Hutang', this)
        })
        .finally(() => (this.isLoadingExportExcel = false))
    },
    importFile(event) {
      this.isLoadingImport = true
      this.dataService
        .import(event.files[0])
        .then((res) => {
          if (res.data.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Import File Saldo Awal Hutang',
              detail: 'Berhasil import Saldo Awal Hutang.',
              life: 3000,
            })
            this.loadGridData()
          } else {
            let msg = []
            res.data.data.forEach((value) => {
              msg.push(value.error)
            })
            this.$toast.add({
              severity: 'error',
              summary: `${res.data.message}`,
              detail: `${msg}`,
              life: 4000,
            })
          }
        })
        .catch((err) => {
          errorHandler(err, 'Import File Saldo Awal Hutang', this)
        })
        .finally(() => (this.isLoadingImport = false))
    },
    downloadTemplate() {
      this.isLoadingTemplateImport = true
      this.dataService
        .templateImport()
        .then((res) => {
          if (res.status !== 200) {
            this.$toast.add({
              severity: 'error',
              summary: 'Download Template Saldo Awal Hutang',
              detail: 'Berhasil mengunduh Template Saldo Awal Hutang.',
              life: 3000,
            })
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'saldo_hutang.xls')
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((err) => {
          errorHandler(err, 'Download Template Saldo Awal Hutang', this)
        })
        .finally(() => (this.isLoadingTemplateImport = false))
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.$router.push({ name: 'SaldoAwalHutangAdd' })
      }
    },
  },
}
</script>
